import { MOCK_USER_A_ID, mockUserA } from '../mockUsers'
import { MOCK_TEAM_A_ID } from '../mockTeams/mockTeamsConstants'
import { MOCK_TASK_A_ID } from '../mockTasks/mockTasksConstants'
import { MessageReducer } from 'state/reducers/types/MessageReducer'

export const mockMessageA: MessageReducer = {
  data: {
    userId: MOCK_USER_A_ID,
    description:
      'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.',
    userPhotoUrl: mockUserA.photoURL,
    userDisplayName: 'Foo Bar',
  },
  teamId: MOCK_TEAM_A_ID,
  taskId: MOCK_TASK_A_ID,
}
